import { validationRules } from '../../../../../../services/validation/rules/validationRules'
import { ValidationSchema } from '../../../../../../@types/validation-types'
import {
  defaultConstruction,
  defaultContactInfo,
  defaultDescription,
  useManualAndInternationalAddress,
} from '../../../../../../services/validation/flow/defaultSchemas'
import { ContentStateInterface } from '../../../../../../@types/types'
import { AddressFeatureState } from '../../../../../../@types/state-types'

function basicInfoSchema() {
  return {
    livingSpace: validationRules.livingSpace,
    room: validationRules.room,
    price: validationRules.price,
    constructionYear: validationRules.constructionYear,
  }
}

function constructionSchema(insertionData: ContentStateInterface, addressFeature: AddressFeatureState) {
  return {
    constructionLastModernization: validationRules.constructionLastModernization,
    thermalCharacteristic: defaultConstruction.thermalCharacteristic(insertionData, addressFeature),
    legalConstructionYear: validationRules.legalConstructionYear,
  }
}

export const propertyOwnerApartmentRentSchema: ValidationSchema = {
  address: useManualAndInternationalAddress,
  basicInfo: basicInfoSchema,
  costs: {
    additionalCosts: validationRules.additionalCosts,
    deposit: validationRules.deposit,
    heatingCosts: validationRules.heatingCosts,
  },
  description: { ...defaultDescription, adFurnishingNote: validationRules.adFurnishingNote },
  contactInfo: defaultContactInfo,
  otherFacilities: {
    noBathrooms: validationRules.noBathrooms,
    noBedrooms: validationRules.noBedrooms,
    floor: validationRules.floor,
    totalFloorsNumber: validationRules.totalFloorsWithDependingFloorNumber,
    usableArea: validationRules.usableArea,
    parkingSpaceRent: validationRules.parkingSpaceRent,
    noParkingSpaces: validationRules.noParkingSpaces,
  },
  construction: constructionSchema,
  tenantDocuments: { solvency: [], rental: [], income: [], selfReport: [], identification: [] },
}
